// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__33CDC","search":"Settings_search__2_J2f","filter":"Settings_filter__1qrky"};